"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.array.includes.js");

require("core-js/modules/es.array.some.js");

require("core-js/modules/es.date.to-string.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.includes.js");

require("core-js/modules/es.string.replace.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getVisible = exports.getAction = exports.getId = exports.getTitle = exports.getActive = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

require("regenerator-runtime/runtime.js");

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _isLogin = require("../constants/isLogin");

var _client = require("@apollo/client");

var _notification = _interopRequireDefault(require("antd/lib/notification"));

var _jsCookie = _interopRequireDefault(require("js-cookie"));

var _isAfter = _interopRequireDefault(require("date-fns/isAfter"));

var _isBefore = _interopRequireDefault(require("date-fns/isBefore"));

var _isValid = _interopRequireDefault(require("date-fns/isValid"));

var _menu = require("../constants/menu");

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n                  fragment viewerFragment on User {\n                    id\n                    locale\n                  }\n                "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n              mutation updateShopperLanguagePreference(\n                $input: UpdateShopperLanguagePreferenceInput!\n              ) {\n                updateShopperLanguagePreference(input: $input) {\n                  status\n                }\n              }\n            "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n            mutation logout {\n              logout @client {\n                status\n              }\n            }\n          "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var getActive = function getActive(url, _ref) {
  var router = _ref.router,
      locale = _ref.locale,
      currency = _ref.currency,
      id = _ref.id,
      action = _ref.action;

  switch (action) {
    case _menu.MENU_ACTION_TYPES.AUTH:
      return /\/login/.test(router.pathname);

    default:
      {
        if (id === locale || id === currency) return true;
        return [router.asPath.replace(/\//g, '%2F'), encodeURIComponent(router.asPath), "http://".concat(router.domain).concat(router.asPath).replace(/\//g, '%2F'), encodeURIComponent("http://".concat(router.domain).concat(router.asPath)), "https://".concat(router.domain).concat(router.asPath).replace(/\//g, '%2F'), encodeURIComponent("https://".concat(router.domain).concat(router.asPath))].includes(encodeURIComponent(url));
      }
  }
};

exports.getActive = getActive;

var getTitle = function getTitle(_ref2) {
  var _user$memberGroup;

  var isLogin = _ref2.isLogin,
      user = _ref2.user,
      t = _ref2.t,
      getLanguage = _ref2.getLanguage,
      id = _ref2.id,
      action = _ref2.action,
      title = _ref2.title,
      params = _ref2.params;

  switch (action) {
    case _menu.MENU_ACTION_TYPES.LOCALE:
      return t("menu:".concat(id));

    case _menu.MENU_ACTION_TYPES.CURRENCY:
      switch (id) {
        case 'CNY':
        case 'JPY':
          return "\xA5 ".concat(id);

        case 'EUR':
          return '€ EUR';

        case 'VND':
          return '₫ VND';

        case 'KRW':
          return '₩ KRW';

        case 'MYR':
          return 'RM MYR';

        case 'TWD':
        case 'USD':
        case 'HKD':
        case 'SGD':
        default:
          return "$ ".concat(id);
      }

    case _menu.MENU_ACTION_TYPES.AUTH:
      if (isLogin !== _isLogin.NOTLOGIN) return params !== null && params !== void 0 && params.displayMemberGroup && user !== null && user !== void 0 && (_user$memberGroup = user.memberGroup) !== null && _user$memberGroup !== void 0 && _user$memberGroup.name ? user.memberGroup.name : null;
      return getLanguage(title);

    default:
      switch (id) {
        case 'ORDERS':
        case 'SETTINGS':
        case 'RECIPIENTS':
        case 'PASSWORD_CHANGE':
        case 'WISHLIST':
        case 'REWARD_POINTS':
        case 'LOGOUT':
          return t("menu:".concat(id));

        default:
          return getLanguage(title);
      }

  }
};

exports.getTitle = getTitle;

var getId = function getId(_ref3) {
  var locale = _ref3.locale,
      currency = _ref3.currency,
      id = _ref3.id,
      action = _ref3.action;
  var isUuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(id);
  if (!isUuid) return id;

  switch (action) {
    case _menu.MENU_ACTION_TYPES.LOCALE:
      return locale;

    case _menu.MENU_ACTION_TYPES.CURRENCY:
      return currency;

    default:
      return id;
  }
};

exports.getId = getId;

var getAction = function getAction(_ref4) {
  var isLogin = _ref4.isLogin,
      user = _ref4.user,
      t = _ref4.t,
      i18n = _ref4.i18n,
      id = _ref4.id,
      action = _ref4.action,
      setCurrency = _ref4.setCurrency,
      client = _ref4.client;

  switch (action) {
    case _menu.MENU_ACTION_TYPES.AUTH_LOGOUT:
      {
        return /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
          var _yield$client$mutate, data;

          return _regenerator["default"].wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return client.mutate({
                    mutation: (0, _client.gql)(_templateObject())
                  });

                case 2:
                  _yield$client$mutate = _context.sent;
                  data = _yield$client$mutate.data;
                  if ((data === null || data === void 0 ? void 0 : data.logout.status) === 'OK') _notification["default"].success({
                    message: t('ducks:signout-success')
                  });else _notification["default"].error({
                    message: t('ducks:signout-failure-message')
                  });

                case 5:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));
      }

    case _menu.MENU_ACTION_TYPES.LOCALE:
      {
        return /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
          var _user$store, _user$store$setting, _user$store$setting$l;

          var isLocaleId;
          return _regenerator["default"].wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  // locale 的選項是從 user.store.setting.locale 中取得
                  // 會巢狀使用 function，所以要擋 page.id
                  isLocaleId = user === null || user === void 0 ? void 0 : (_user$store = user.store) === null || _user$store === void 0 ? void 0 : (_user$store$setting = _user$store.setting) === null || _user$store$setting === void 0 ? void 0 : (_user$store$setting$l = _user$store$setting.locale) === null || _user$store$setting$l === void 0 ? void 0 : _user$store$setting$l.includes(id);

                  if (isLocaleId) {
                    _context2.next = 3;
                    break;
                  }

                  return _context2.abrupt("return");

                case 3:
                  if (!(isLogin !== _isLogin.NOTLOGIN)) {
                    _context2.next = 6;
                    break;
                  }

                  _context2.next = 6;
                  return client.mutate({
                    mutation: (0, _client.gql)(_templateObject2()),
                    variables: {
                      input: {
                        locale: id
                      }
                    },
                    update: function update(cache, _ref7) {
                      var updateShopperLanguagePreference = _ref7.data.updateShopperLanguagePreference;
                      if (user !== null && user !== void 0 && user.id || updateShopperLanguagePreference.status !== 'OK') return;
                      cache.writeFragment({
                        id: user.id,
                        fragment: (0, _client.gql)(_templateObject3()),
                        data: {
                          __typename: 'User',
                          id: user.id,
                          locale: id
                        }
                      });
                    }
                  });

                case 6:
                  i18n.changeLanguage(id);

                  _jsCookie["default"].set('next-i18next-browser', id);

                case 8:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));
      }

    case _menu.MENU_ACTION_TYPES.CURRENCY:
      {
        return function () {
          var _user$store2, _user$store2$setting, _user$store2$setting$;

          // currency 的選項是從 user.store.setting.currency 中取得
          // 會巢狀使用 function，所以要擋 page.id
          var isCurrencyId = user === null || user === void 0 ? void 0 : (_user$store2 = user.store) === null || _user$store2 === void 0 ? void 0 : (_user$store2$setting = _user$store2.setting) === null || _user$store2$setting === void 0 ? void 0 : (_user$store2$setting$ = _user$store2$setting.currency) === null || _user$store2$setting$ === void 0 ? void 0 : _user$store2$setting$.includes(id);
          if (!isCurrencyId) return;
          setCurrency(id);
        };
      }

    default:
      return undefined;
  }
};

exports.getAction = getAction;

var isInTimeRange = function isInTimeRange(_ref8) {
  var startTime = _ref8.startTime,
      endTime = _ref8.endTime,
      now = _ref8.now;

  if (startTime && (0, _isValid["default"])(new Date(startTime))) {
    if (!(0, _isBefore["default"])(new Date(startTime), now)) return false;
  }

  if (endTime && (0, _isValid["default"])(new Date(endTime))) {
    if (!(0, _isAfter["default"])(new Date(endTime), now)) return false;
  }

  return true;
};

var getVisible = function getVisible(_ref9) {
  var now = _ref9.now,
      isVisible = _ref9.isVisible,
      visibleStartTime = _ref9.visibleStartTime,
      visibleEndTime = _ref9.visibleEndTime,
      pages = _ref9.pages,
      url = _ref9.url,
      path = _ref9.path;

  /* 有些像「登入」這種特殊的 menu item 可能不會有 isVisible，因此直接回傳 isVisible = true */
  if (typeof isVisible !== 'boolean') return {
    isVisible: true,
    isChildrenVisible: (pages === null || pages === void 0 ? void 0 : pages.length) > 0
  };
  /* 先判斷自己是否 visible */

  if (!(isVisible && isInTimeRange({
    startTime: visibleStartTime,
    endTime: visibleEndTime,
    now: now
  }))) return {
    isVisible: false
  };
  /**  如果有子頁面，自身「有 url」=> visible
   * 沒有 url、path 的話 => 判斷子頁面是否 visible
   * 若子頁面 all invisible，則自身 => invisible */

  if (pages !== null && pages !== void 0 && pages.length) {
    var hasVisibleChild = pages.some(function (child) {
      var _child$params, _child$params2, _child$params3, _child$params4, _child$params5;

      var childVisible = getVisible({
        now: now,
        isVisible: child === null || child === void 0 ? void 0 : (_child$params = child.params) === null || _child$params === void 0 ? void 0 : _child$params.isVisible,
        visibleStartTime: child === null || child === void 0 ? void 0 : (_child$params2 = child.params) === null || _child$params2 === void 0 ? void 0 : _child$params2.visibleStartTime,
        visibleEndTime: child === null || child === void 0 ? void 0 : (_child$params3 = child.params) === null || _child$params3 === void 0 ? void 0 : _child$params3.visibleEndTime,
        pages: child === null || child === void 0 ? void 0 : child.pages,
        url: child === null || child === void 0 ? void 0 : (_child$params4 = child.params) === null || _child$params4 === void 0 ? void 0 : _child$params4.url,
        path: child === null || child === void 0 ? void 0 : (_child$params5 = child.params) === null || _child$params5 === void 0 ? void 0 : _child$params5.path
      });
      return childVisible.isVisible;
    });
    var hasLink = !!url || !!path;
    /* 如果有子頁面，且子頁面也都隱藏，但是母頁面有 link 需要存在時，需要把下拉的 arrow 也隱藏，因此需要多傳一個參數 isChildrenVisible */

    return {
      isVisible: hasLink || hasVisibleChild,
      isChildrenVisible: hasVisibleChild
    };
  }

  return {
    isVisible: true
  };
};

exports.getVisible = getVisible;